// Formulário público da empresa (pedido 2026-10-05) — /f/:slug, sem login
// (bypass em __root.tsx, igual /indicacao). Montado em Administração →
// Formulários; o visual (cor, fundo, banner) vem do próprio formulário.
import { createFileRoute } from "@tanstack/react-router";
import { useEffect, useState } from "react";
import { FileX2, Loader2 } from "lucide-react";
import { FormRenderer } from "@/components/forms/form-renderer";
import { GpsDriveApiError, resolveGpsDriveUrl } from "@/lib/api/gpsdrive-client";
import { gpsDriveFormsService, type PublicForm } from "@/services/gpsdrive-forms.service";

export const Route = createFileRoute("/f/$slug")({
  head: () => ({
    meta: [{ title: "Formulário" }, { name: "theme-color", content: "#0f172a" }],
  }),
  component: PublicFormPage,
});

function PublicFormPage() {
  const { slug } = Route.useParams();
  const [form, setForm] = useState<PublicForm | null>(null);
  const [state, setState] = useState<"loading" | "ok" | "missing" | "error">("loading");

  useEffect(() => {
    let cancelled = false;
    gpsDriveFormsService
      .publicGet(slug)
      .then((f) => {
        if (cancelled) return;
        setForm({
          ...f,
          bannerUrl: f.bannerUrl ? resolveGpsDriveUrl(f.bannerUrl) : null,
          logoUrl: f.logoUrl ? resolveGpsDriveUrl(f.logoUrl) : null,
        });
        setState("ok");
        document.title = f.title;
      })
      .catch((e) => {
        if (cancelled) return;
        setState(e instanceof GpsDriveApiError && e.status === 404 ? "missing" : "error");
      });
    return () => {
      cancelled = true;
    };
  }, [slug]);

  if (state === "loading") {
    return (
      <div className="flex min-h-screen items-center justify-center bg-slate-950 text-white">
        <Loader2 className="h-8 w-8 animate-spin opacity-70" />
      </div>
    );
  }

  if (state !== "ok" || !form) {
    return (
      <div className="flex min-h-screen flex-col items-center justify-center gap-3 bg-slate-950 px-6 text-center text-white">
        <FileX2 className="h-12 w-12 opacity-60" />
        <h1 className="text-xl font-bold">
          {state === "missing" ? "Formulário indisponível" : "Não foi possível abrir o formulário"}
        </h1>
        <p className="max-w-sm text-sm text-white/60">
          {state === "missing"
            ? "Este link não existe mais ou o formulário foi desativado pela empresa."
            : "Verifique sua conexão e tente novamente."}
        </p>
      </div>
    );
  }

  return (
    <FormRenderer
      form={form}
      className="min-h-screen"
      onSubmit={async (answers) => {
        await gpsDriveFormsService.publicSubmit(slug, answers);
      }}
    />
  );
}
